/**
 * @file page
 * @Author ytyjm
 * @Create 17:02 2020/6/12
 * @Version 1.0
 * @Description:
 */
const state = {
  initLink: ''
}
const mutations = {
  setInitLink (state, initLink) {
    state.initLink = initLink
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
